import {SaleReportStatus} from '../sale';
import {Dropdown} from './dropdown';

const SALE_REPORT_STATUS_OPTIONS_FR: Dropdown<SaleReportStatus>[] = [
  {name: 'En cours', value: SaleReportStatus.ONGOING},
  {name: 'Illustration', value: SaleReportStatus.ILLUSTRATION},
  {name: 'En tarification', value: SaleReportStatus.UNDERWRITING},
  {name: 'En vigueur', value: SaleReportStatus.IN_FORCE},
  {name: `Approuvé par l'assureur`, value: SaleReportStatus.APPROVED_BY_INSURER},
  {name: `Refusé par l'assureur`, value: SaleReportStatus.REFUSED_BY_INSURER},
  {name: 'Refusé par le client', value: SaleReportStatus.REFUSED_BY_CLIENT},
  {name: 'Déchéance', value: SaleReportStatus.LAPSED},
  {name: 'Délai de grâce', value: SaleReportStatus.UNPAID},
  {name: 'Inconnu', value: SaleReportStatus.UNKNOWN},
  {name: 'Abandonné', value: SaleReportStatus.ABANDONED},
];

const SALE_REPORT_STATUS_OPTIONS_EN: Dropdown<SaleReportStatus>[] = [
  {name: 'In progress', value: SaleReportStatus.ONGOING},
  {name: 'Illustration', value: SaleReportStatus.ILLUSTRATION},
  {name: 'In underwriting', value: SaleReportStatus.UNDERWRITING},
  {name: 'In force', value: SaleReportStatus.IN_FORCE},
  {name: 'Approved by insurer', value: SaleReportStatus.APPROVED_BY_INSURER},
  {name: 'Refused by insurer', value: SaleReportStatus.REFUSED_BY_INSURER},
  {name: 'Refused by customer', value: SaleReportStatus.REFUSED_BY_CLIENT},
  {name: 'Decline', value: SaleReportStatus.LAPSED},
  {name: 'Grace period', value: SaleReportStatus.UNPAID},
  {name: 'Unknown', value: SaleReportStatus.UNKNOWN},
  {name: 'Abandoned', value: SaleReportStatus.ABANDONED},
];

export const SALE_REPORT_STATUS_OPTIONS = {
  en: SALE_REPORT_STATUS_OPTIONS_EN,
  fr: SALE_REPORT_STATUS_OPTIONS_FR,
};
